module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "width": "620px",
      "modal-append-to-body": false,
      "close-on-click-modal": false,
      "custom-class": "link-campus-dialog"
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [(!_vm.isEdit) ? _c('div', {
    staticClass: "link-campus-body link-campus-body--view"
  }, [(_vm.viewCampusScope === 'all') ? _c('div', {
    staticClass: "link-campus-all-hint"
  }, [_vm._v("全部校区")]) : _c('div', {
    staticClass: "link-campus-view-scroll"
  }, [(_vm.campusModels.length) ? _vm._l((_vm.campusModels), function(m, i) {
    return _c('span', {
      key: m.unid || i,
      staticClass: "link-campus-view-name"
    }, [_vm._v(_vm._s(m.name)), (i < _vm.campusModels.length - 1) ? [_vm._v("、")] : _vm._e()], 2)
  }) : _c('div', {
    staticClass: "link-campus-empty"
  }, [_vm._v("暂无关联校区")])], 2)]) : _c('div', {
    staticClass: "link-campus-body link-campus-body--edit"
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 适用校区\n            ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.campusScope),
      callback: function($$v) {
        _vm.campusScope = $$v
      },
      expression: "campusScope"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "partial"
    }
  }, [_vm._v("部分校区")])], 1), _vm._v(" "), (_vm.campusScope === 'partial') ? _c('div', {
    staticClass: "campus-partial"
  }, [_c('div', {
    staticClass: "campus-select-row"
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "placeholder": "请选择校区",
      "filterable": ""
    },
    model: {
      value: (_vm.campusForm.unid),
      callback: function($$v) {
        _vm.$set(_vm.campusForm, "unid", $$v)
      },
      expression: "campusForm.unid"
    }
  }, _vm._l((_vm.campusZoneList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "campus-add-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddCampus
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "campus-card-wrap"
  }, _vm._l((_vm.campusModels), function(item) {
    return _c('div', {
      key: item.unid,
      staticClass: "campus-dialog-item"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteCampus(item.unid)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "campus-card-footer"
  }, [_vm._v("共计" + _vm._s(_vm.campusModels.length) + "所学校")])]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer link-campus-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isEdit) ? [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.enterEdit
    }
  }, [_vm._v("编辑")])] : [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13e2d304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/LinkCampusDialog.vue
// module id = 947
// module chunks = 0